import { map } from 'lodash';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import DataTable from '../../../core/components/DataTable';
import Loader from '../../../core/components/Loader';
import { getApiStatus } from '../../../core/utils';

const HourlyWashCountsTable = ({
  intl,
  hourlyWashCounts,
  classNames,
  washTypeFilter,
  fromDate,
}) => {
  const apiIsLoading = useSelector((state) => getApiStatus(state, 'FETCH_HOURLY_WASH_COUNTS'));

  const headers = [
    { name: intl.formatMessage({ id: 'time' }) },
    { name: intl.formatMessage({ id: 'count' }) },
  ];

  const handleHourlyWashCountFilter = () => {
    const tz = sessionStorage.getItem('timeZone');
    const today = moment.tz(tz);
    // if the current date is in the past, don't filter the data
    if (moment.tz(fromDate, tz).format('YYYY-MM-DD') === today.format('YYYY-MM-DD')) {
      // loop through response and remove the keys(hours) that are in the future
      const futureKeys = _.keys(hourlyWashCounts).filter((key) => {
        return parseInt(key) > moment.tz(tz).hour();
      });
      const filteredHourlyWashCounts = _.omit(hourlyWashCounts, futureKeys);
      return filteredHourlyWashCounts;
    }
    return hourlyWashCounts;
  };

  const getTableData = () => {
    const filteredHourlyWashCounts = handleHourlyWashCountFilter();
    return map(filteredHourlyWashCounts, (hourlyCounts, hour) => {
      const count =
        washTypeFilter === 'interior'
          ? hourlyCounts.interiorCountsBySiteId || 0
          : washTypeFilter === 'exterior'
          ? hourlyCounts.exteriorCountsBySiteId || 0
          : hourlyCounts.count || 0;

      return {
        _id: hour,

        hour: moment(hour, 'hour').format('ha'),
        count,
      };
    });
  };

  const initializeDataTable = () => {
    return {
      headers,
      data: getTableData(),
      addedClass: 'mb-0',
    };
  };

  return (
    <div className={`wash-chart hourly-counts mt-3 shadowed ${classNames}`}>
      {!apiIsLoading ? (
        <span>
          <div className="wash-chart-label">{intl.formatMessage({ id: 'hourlyWashCounts' })}</div>
          <DataTable {...initializeDataTable()} />
        </span>
      ) : (
        <Loader />
      )}
    </div>
  );
};

HourlyWashCountsTable.propTypes = {
  intl: PropTypes.shape({}).isRequired,
  hourlyWashCounts: PropTypes.shape({}).isRequired,
  classNames: PropTypes.string,
};

export default HourlyWashCountsTable;
